import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { ApiService } from "src/app/services/api.service";
import { WalletHelperService } from "src/app/services/wallet-helper.service";

@Component({
  selector: "app-select-from-asset",
  templateUrl: "./select-from-asset.page.html",
  styleUrls: ["./select-from-asset.page.scss"],
})
export class SelectFromAssetPage implements OnInit {
  swapPairs: any;
  selectedPair: any;
  selectedAsset: any = null;
  selectedAssetWallets: Array<any> = [];
  fromWallet: any;
  toWallet: any;

  math: any = Math;

  pan_number: string;
  bank_account_number: string;
  bank_account_ifsc: string;

  constructor(
    private modalCtrl: ModalController,
    public navParams: NavParams,
    public api: ApiService,
    private walletHelper: WalletHelperService
  ) {
    this.swapPairs = this.navParams.get("swapPairs");
    this.selectedPair = this.navParams.get("selectedPair");
    this.fromWallet = this.navParams.get("fromWallet");
    this.toWallet = this.navParams.get("toWallet");

    console.log(this.swapPairs);
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(null);
  }

  selectAsset(asset_id: number) {
    this.selectedAssetWallets = [];

    for (let i = 0; i < this.swapPairs.length; i++) {
      if (this.swapPairs[i].asset_id == asset_id) {
        this.selectedAsset = this.swapPairs[i];
      }
    }

    for (let i = 0; i < this.api.wallets.length; i++) {
      if (
        this.api.wallets[i].blockchain_id == this.selectedAsset.blockchain_id
      ) {
        let wallet = this.api.wallets[i];
        this.selectedAssetWallets.push(wallet);
      }
    }
  }

  resetSelection() {
    this.selectedAsset = null;
    this.selectedAssetWallets = [];
  }

  /**
   * select Wallet
   * @param wallet_id
   */
  selectWallet(wallet_id: number) {
    for (let i = 0; i < this.api.wallets.length; i++) {
      if (this.api.wallets[i].wallet_id == wallet_id) {
        let wallet = this.api.wallets[i];
        this.fromWallet = wallet;
      }
    }
    let data = {
      fromAsset: this.selectedAsset,
      fromWallet: this.fromWallet,
    };

    this.modalCtrl.dismiss(data);
  }
}
